module.exports = __webpack_public_path__ + "static/img/volume-of-content.ddb46bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/volume-of-content.png
// module id = sl+a
// module chunks = 0